export class ProductInventory {
  sku: string;
  size: string;
  inStock: number;

  constructor() {}
}
